/**
 * Modèle des listes de contrôle pour la nouvelle interface "Mes listes" (ticket wilout/issues#4956).
 * Mappe le document brut renvoyé par GET /api/liste/list vers un objet d'affichage typé.
 */

export type ListeStatus = 'active' | 'inactive' | 'expired';

/** Patch d'état persistable d'une liste (PATCH /api/liste/state). */
export interface ListStatePatch {
  isDefault?: boolean;
  archived?: boolean;
  hidden?: boolean;
  flag?: boolean;
}

/** Document brut tel que renvoyé/stocké (localStorage dataList / dataAllLists). */
export interface RawListe {
  _id: string;
  name: string;
  actif?: boolean;
  isPast?: boolean;
  dateEndValide?: string;        // 'DD-MM-YYYY HH:mm:ss'
  creationDate?: string;
  tpl?: Array<{ id: string; scanNbr?: number; name?: string; infinity?: boolean | string }>;
  flag?: boolean;
  isDefault?: boolean;
  default?: boolean;             // ancien champ historique
  archived?: boolean;
  hidden?: boolean;
  order?: number;
  sd?: string;             // clé de tri (creationDate) calculée par processRawListes
  ed?: string;             // clé de tri (dateEndValide) calculée par processRawListes
}

/** Vue d'affichage d'une liste de contrôle. */
export interface ListeControle {
  id: string;
  name: string;
  status: ListeStatus;
  isDefault: boolean;
  flag: boolean;
  archived: boolean;
  hidden: boolean;
  order: number | null;
  validUntil: string | null;     // brut 'DD-MM-YYYY HH:mm:ss'
  tarifs: number;
  raw: RawListe;                 // document original, requis pour la sélection (dataList)
}

const computeStatus = (raw: RawListe): ListeStatus => {
  if (raw.isPast === true) return 'expired';
  if (raw.actif === true) return 'active';
  return 'inactive';
};

export const mapRawToListe = (raw: RawListe): ListeControle => ({
  id: raw._id,
  name: raw.name,
  status: computeStatus(raw),
  isDefault: raw.isDefault === true || raw.default === true,
  flag: raw.flag === true,
  archived: raw.archived === true,
  hidden: raw.hidden === true,
  order: typeof raw.order === 'number' ? raw.order : null,
  validUntil: raw.dateEndValide ?? null,
  tarifs: Array.isArray(raw.tpl) ? raw.tpl.length : 0,
  raw,
});

/** Formate 'DD-MM-YYYY HH:mm:ss' → 'DD/MM/YYYY à HHhMM'. */
export const formatValidUntil = (value: string | null): string => {
  if (!value || value.length < 16) return '';
  const [datePart, timePart] = value.split(' ');
  const date = datePart.replace(/-/g, '/');
  const [h, m] = (timePart ?? '').split(':');
  return h && m ? `${date} à ${h}h${m}` : date;
};
